module.exports = __webpack_public_path__ + "static/media/cover.96fa66fb.jpg";